import {EventEmitter} from 'UTILS';

export const dispatcher = new EventEmitter<any>();
export default dispatcher;